import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./styles/app.scss";
import App from "./App";
var router = createBrowserRouter([
    {
        path: "*",
        element: _jsx(App, {}),
    },
]);
ReactDOM.createRoot(document.getElementById("app")).render(_jsx(RouterProvider, { router: router }));
